import React from 'react';
import './skills.css';
import frontend from '../Assets/frontend.png';



 const Skills = () => {
  return (
   <section id='skills'>
<span className='skillTitle'>What I do</span>
<span className='skillDesc'>As a skilled front-end developer, I specialize in creating visually appealing and highly interactive user interfaces. I have an in-depth understanding of modern front-end technologies and best practices, allowing me to craft responsive, accessible, and user-friendly web applications. </span>
<div className='skillCards'>

<div className='frontendCard'>
<img src={frontend} alt='frontendimg' className='frontendImg'/>
<div className='frontendCardText'>
  <h2>Frontend Web Development</h2>
  <p>My front-end toolkit includes proficiency in HTML, CSS, and JavaScript, as well as expertise in popular front-end frameworks and libraries such as React.js ,Next.js ,Angular.js. I'm adept at leveraging these tools to build dynamic, single-page applications  that provide seamless and efficient user experiences.</p>
</div>
</div>




</div>
   </section>
  );
}
export default Skills